import React from 'react';
import withDrilldown from '../../withDrilldown';
import Drilldown from './Drilldown';

const InputWithDrillDown = withDrilldown(Drilldown, { field: '', text: '' });

export default function EnployeeInput(props) {
	return <InputWithDrillDown {...props} />;
}
